// Shared Tailwind class names so buttons, links and inputs match on every page.

const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2";

export const container = "mx-auto w-full max-w-6xl px-4 sm:px-6";

export const buttons = {
  primary: `inline-flex items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60 ${focusRing}`,
  secondary: `inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-50 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-60 ${focusRing}`,
  ghost: `inline-flex items-center justify-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 ${focusRing}`,
  link: `inline-flex items-center gap-1 rounded-sm font-semibold text-blue-700 underline-offset-4 hover:text-blue-800 hover:underline ${focusRing}`,
};

export const field = {
  label: "block text-sm font-medium text-slate-800",
  input:
    "mt-1.5 block w-full rounded-md border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20",
  invalid: "border-red-600 focus:border-red-600 focus:ring-red-600/20",
  error: "mt-1.5 text-sm text-red-700",
  hint: "mt-1.5 text-sm text-slate-500",
};
